import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-434f1751"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline-skeleton" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-title" }),
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-button" })
], -1))
const _hoisted_3 = { class: "skeleton-timeline-container" }
const _hoisted_4 = { class: "skeleton-months" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-timeline-line" }, null, -1))
const _hoisted_6 = { class: "skeleton-events" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-event-bubble" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-event-title" }),
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-event-description" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-connection-line" }, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-controls" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-control-button" }),
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-control-button" })
], -1))
const _hoisted_11 = { class: "skeleton-loading-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
          return _createElementVNode("div", {
            key: `month-${i}`,
            class: "skeleton-month",
            style: _normalizeStyle({ animationDelay: `${i * 0.1}s` })
          }, null, 4)
        }), 64))
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
          return _createElementVNode("div", {
            key: `event-${i}`,
            class: _normalizeClass(["skeleton-event", { 'position-above': i % 2 === 0, 'position-below': i % 2 === 1 }]),
            style: _normalizeStyle({ 
            left: `${(i * 120) + 80}px`,
            animationDelay: `${i * 0.2}s` 
          })
          }, _hoisted_9, 6)
        }), 64))
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_v_progress_circular, {
        indeterminate: "",
        color: "primary",
        size: "24",
        width: "3",
        class: "mr-3"
      }),
      _createTextVNode(" Loading roadmap data... ")
    ])
  ]))
}